<div
  class="sidenav-container"
  [class.collapsed]="isNavCollapsed"
  [class.mobile-nav-open]="isMobileNavOpen"
>
  <div class="logo-container">
    <app-logo *ngIf="!isNavCollapsed"></app-logo>
    <img
      *ngIf="isNavCollapsed"
      src="/assets/images/sidebar/logo-small.svg"
      alt="Small Logo"
      class="small-logo"
    />
    <button class="close-menu-button" (click)="toggleCollapse()">
      <img
        [src]="
          isNavCollapsed
            ? '/assets/images/sidebar/chevron-right.svg'
            : '/assets/images/sidebar/chevron-left.svg'
        "
        alt="Toggle menu"
      />
    </button>
  </div>
  <div class="menu-container">
    <div class="menu-scrollable">
      <div class="menu-section">
        <ul class="menu-items">
          <li class="menu-item" *ngFor="let item of primaryNav" routerLinkActive="active">
            <a
              [routerLink]="item.path"
              class="menu-link"
              (click)="closeMobileNav()"
              (mouseenter)="onMenuLinkMouseEnter($event)"
            >
              <span class="menu-icon">
                <img [src]="item.icon" [alt]="item.label" />
              </span>
              <span class="menu-text" *ngIf="!isNavCollapsed">{{ item.label }}</span>
              <span class="menu-tooltip" *ngIf="isNavCollapsed">{{ item.label }}</span>
            </a>
          </li>
        </ul>
      </div>

      <div class="menu-section">
        <p class="menu-section-label" *ngIf="!isNavCollapsed">System</p>
        <ul class="menu-items">
          <li class="menu-item" *ngFor="let item of systemNav" routerLinkActive="active">
            <a
              [routerLink]="item.path"
              class="menu-link"
              (click)="closeMobileNav()"
              (mouseenter)="onMenuLinkMouseEnter($event)"
            >
              <span class="menu-icon">
                <img [src]="item.icon" [alt]="item.label" />
              </span>
              <span class="menu-text" *ngIf="!isNavCollapsed">{{ item.label }}</span>
              <span class="menu-tooltip" *ngIf="isNavCollapsed">{{ item.label }}</span>
            </a>
          </li>
        </ul>
      </div>

      <div class="menu-section">
        <p class="menu-section-label" *ngIf="!isNavCollapsed">Diagnostics</p>
        <ul class="menu-items">
          <li class="menu-item" *ngFor="let item of diagnosticsNav" routerLinkActive="active">
            <a
              [routerLink]="item.path"
              class="menu-link"
              (click)="closeMobileNav()"
              (mouseenter)="onMenuLinkMouseEnter($event)"
            >
              <span class="menu-icon">
                <img [src]="item.icon" [alt]="item.label" />
              </span>
              <span class="menu-text" *ngIf="!isNavCollapsed">{{ item.label }}</span>
              <span class="menu-tooltip" *ngIf="isNavCollapsed">{{ item.label }}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
